export const availableGroupActions = {
  in: 'in',
  out: 'out',
}
